import angular from 'angular';
import { get, cloneDeep, forEach, head, includes, map } from 'lodash';
import { schedule, options, unitOfTime } from '../../utils';
import 'angular-ui-tree';
import '../../services/organization-area';
import '../../services/errors';
import '../../components/osom';
import '../../components/schedule/exact-schedules';

const module = angular.module('whyline.modals.organization-area', [
  'whyline.services.organization-area',
  'whyline.services.errors',
  'whyline.components.osom',
  'whyline.components.exactSchedule',
  'whyline.services.organization',
]);

const OrganizationAreaModalController = (
  $scope,
  $timeout,
  $state,
  $uibModalInstance,
  $translate,
  GlobalsService,
  NotificationService,
  OrganizationAreaService,
  organizationAreaId,
  ErrorService,
  OrganizationService,
) => {
  'ngInject';

  const namePattern = /^[ '-:\u0621-\u064Aa-zA-Z\xC0-\xCF\xD1-\xD6\xD8-\xDD\xDF-\xE5\xE7-\xF6\xF8-\xFD\xFF\u0104-\u0107\u010C\u010D\u0116-\u0119\u012E\u012F\u0141-\u0144\u0152\u0160\u0161\u016A\u016B\u0172\u0173\u0178-\u017E]+$/;
  const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/i;

  $scope.organization = OrganizationService.GetCurrent();
  $scope.enterpriseType = GlobalsService.EnterpriseType;
  $scope.title = 'processes';
  $scope.exactSchedule = schedule.reOrder(schedule.createExactDaySchedule());
  $scope.blockSaveButton = false;
  $scope.delayDeliveryUnitOfTime = {
    options: unitOfTime,
  };
  $scope.surveyMonkey = {};
  $scope.selectData = {
    options: options.filter((o) => o.onlyOrganizations || o.all),
    selectedOption: options.filter((o) => o.onlyOrganizations || o.all)[0].key,
  };
  $scope.selectDataMessages = {
    options: options.filter((o) => o.onlyOrganizations || o.all),
    selectedOption: options.filter((o) => o.onlyOrganizations || o.all)[0].key,
  };
  $scope.selectDataForWithoutAppointment = {
    options: options.filter((o) => o.onlyOrganizations || o.all),
    selectedOption: options.filter((o) => o.onlyOrganizations || o.all)[0].key,
  };
  $scope.items = [];
  $scope.dynamicLines = [];
  $scope.hours = schedule.getHours();
  $scope.organizationArea = {
    schedule: schedule.reOrder(schedule.create()),
    maxNumbers: 0,
    isWithoutAppointment: true,
    isWithAppointment: $scope.enterpriseType === 'ba',
    withoutAppointment: {
      withPriority: true,
      withoutPriority: true,
      requestSource: {
        mobileApp: true,
        reception: true,
        totem: true,
      },
    },
    configuration: {
      postMessage: '',
    },
    appointmentsFromTotem: false,
    aliasPrefix: '',
    dynamic: false,
  };
  $scope.showEditAttributes = false;
  $scope.linkedProfessionalIdShouldBeVisible =
    $scope.organization.configuration.agenda.supportsLinkedProfessionals;

  const populateAlreadyShown = () => {
    $scope.itemsPopulated = {};
    const lines = $scope.organizationArea.dynamic
      ? map($scope.dynamicLines, (item) => ({
          _id: item.organizationLineId,
          label: item.label,
          type: 'organization-line',
        }))
      : $scope.items;
    forEach(lines, (line) => {
      $scope.itemsPopulated[line._id] = line;
    });
  };

  const resetDynamicProperties = () => {
    if ($scope.dynamicLines.length) {
      $scope.dynamicLines.forEach((item) => {
        const itemIndex = $scope.dynamicLines.findIndex(
          (dl) => dl.organizationLineId === item.organizationLineId,
        );
        item.isFirst = !itemIndex;
        item.pinned = itemIndex ? item.pinned : true;
        item.order = itemIndex;
      });
    }
  };

  const populateSurveyMonkey = () => {
    const savedCompletedDelayDeliveryUnit = get(
      $scope.organizationArea,
      'surveyMonkey.completed.delayDelivery.unit',
      null,
    );

    const completedSelectedOption = $scope.delayDeliveryUnitOfTime.options.find(
      (o) => o.key === savedCompletedDelayDeliveryUnit,
    );

    $scope.delayDeliveryUnitOfTime.completedSelectedOption = completedSelectedOption
      ? completedSelectedOption.key
      : $scope.delayDeliveryUnitOfTime.options[0].key;

    const savedCanceledDelayDeliveryUnit = get(
      $scope.organizationArea,
      'surveyMonkey.canceled.delayDelivery.unit',
      null,
    );

    const canceledSelectedOption = $scope.delayDeliveryUnitOfTime.options.find(
      (o) => o.key === savedCanceledDelayDeliveryUnit,
    );

    $scope.delayDeliveryUnitOfTime.canceledSelectedOption = canceledSelectedOption
      ? canceledSelectedOption.key
      : $scope.delayDeliveryUnitOfTime.options[0].key;

    $scope.surveyMonkey = {
      completed: {
        enabled: get($scope.organizationArea, 'surveyMonkey.completed.enabled', false),
        link: get($scope.organizationArea, 'surveyMonkey.completed.link', ''),
        delayDelivery: {
          value: get($scope.organizationArea, 'surveyMonkey.completed.delayDelivery.value', 0),
          unit: $scope.delayDeliveryUnitOfTime.completedSelectedOption,
        },
      },
      canceled: {
        enabled: get($scope.organizationArea, 'surveyMonkey.canceled.enabled', false),
        link: get($scope.organizationArea, 'surveyMonkey.canceled.link', ''),
        delayDelivery: {
          value: get($scope.organizationArea, 'surveyMonkey.canceled.delayDelivery.value', 0),
          unit: $scope.delayDeliveryUnitOfTime.canceledSelectedOption,
        },
      },
    };
  };

  const saveSurveyMonkeySettings = () => {
    let surveyMonkeyCompleted = {
      enabled: false,
      link: '',
      delayDelivery: {
        value: 0,
        unit: '',
      },
    };

    let surveyMonkeyCanceled = {
      enabled: false,
      link: '',
      delayDelivery: {
        value: 0,
        unit: '',
      },
    };

    if (get($scope.surveyMonkey, 'completed.enabled', false)) {
      surveyMonkeyCompleted = {
        enabled: true,
        link: get($scope.surveyMonkey, 'completed.link'),
        delayDelivery: {
          value: get($scope.surveyMonkey, 'completed.delayDelivery.value'),
          unit: $scope.delayDeliveryUnitOfTime.completedSelectedOption,
        },
      };
    }

    if (get($scope.surveyMonkey, 'canceled.enabled', false)) {
      surveyMonkeyCanceled = {
        enabled: true,
        link: get($scope.surveyMonkey, 'canceled.link'),
        delayDelivery: {
          value: get($scope.surveyMonkey, 'canceled.delayDelivery.value'),
          unit: $scope.delayDeliveryUnitOfTime.canceledSelectedOption,
        },
      };
    }

    const surveyMonkey = {
      completed: surveyMonkeyCompleted,
      canceled: surveyMonkeyCanceled,
    };

    return surveyMonkey;
  };

  const validateSurveyMonkey = () => {
    const completedEnabled = get($scope.surveyMonkey, 'completed.enabled', false);
    const completedLink = get($scope.surveyMonkey, 'completed.link', '');
    const completedDelayDeliveryValue = get(
      $scope.surveyMonkey,
      'completed.delayDelivery.value',
      '',
    );
    const completedDelayDeliveryUnit = $scope.delayDeliveryUnitOfTime.completedSelectedOption;

    const canceledEnabled = get($scope.surveyMonkey, 'canceled.enabled', false);
    const canceledLink = get($scope.surveyMonkey, 'canceled.link', '');
    const canceledDelayDeliveryValue = get($scope.surveyMonkey, 'canceled.delayDelivery.value', '');
    const canceledDelayDeliveryUnit = $scope.delayDeliveryUnitOfTime.canceledSelectedOption;

    const minDelayDeliveryValue = 10;
    const minDelayDeliveryUnit = $scope.delayDeliveryUnitOfTime.options[0];

    if ((completedEnabled && !completedLink) || (canceledEnabled && !canceledLink)) {
      const message = $translate.instant(
        $translate.instant('mandatory_{name}').replace('{name}', 'link'),
      );
      NotificationService.Warning(message);
      return false;
    }

    if (
      (completedEnabled && !completedDelayDeliveryValue) ||
      (canceledEnabled && !canceledDelayDeliveryValue)
    ) {
      const message = $translate.instant(
        $translate
          .instant('mandatory_{name}')
          .replace('{name}', $translate.instant('survey_delay_delivery')),
      );
      NotificationService.Warning(message);
      return false;
    }

    if (
      (completedEnabled &&
        completedDelayDeliveryValue &&
        completedDelayDeliveryValue < minDelayDeliveryValue &&
        completedDelayDeliveryUnit === minDelayDeliveryUnit.key) ||
      (canceledEnabled &&
        canceledDelayDeliveryValue &&
        canceledDelayDeliveryValue < minDelayDeliveryValue &&
        canceledDelayDeliveryUnit === minDelayDeliveryUnit.key)
    ) {
      const message = $translate
        .instant('survey_delay_delivery_message_minimum_validation')
        .replace('{minValue}', minDelayDeliveryValue)
        .replace('{minUnit}', $translate.instant('seconds'));
      NotificationService.Warning(message);
      return false;
    }

    return true;
  };

  const validate = () => {
    const preJoin = get($scope, 'organizationArea.configuration.messages.preJoin', {
      text: '',
      button: {
        label: '',
        url: '',
      },
    });
    const preJoinButtonLabel = get(preJoin, 'button.label', '');
    const preJoinButtonUrl = get(preJoin, 'button.url', '');
    const linesToValidate = $scope.organizationArea.dynamic ? $scope.dynamicLines : $scope.items;

    if (!$scope.validateLabel($scope.organizationArea.label)) {
      return false;
    }
    if (!$scope.validateDescription($scope.organizationArea.description)) {
      return false;
    }
    if (!$scope.validateAliasPrefixDecorator($scope.organizationArea.aliasPrefix)) {
      return false;
    }
    if (!$scope.validateMessage(get($scope.organizationArea.configuration, 'postMessage', ''))) {
      return false;
    }
    if (!$scope.validateLines(linesToValidate)) {
      return false;
    }
    if (get(preJoin, 'text') && preJoin.text.length > 300) {
      NotificationService.Warning($translate.instant('max_length_pre_join_message'));
      return false;
    }
    if (preJoinButtonLabel && preJoinButtonUrl && !get(preJoin, 'text')) {
      NotificationService.Warning($translate.instant('prejoin_empty_text'));
      return false;
    }
    if (!preJoinButtonLabel && preJoinButtonUrl) {
      NotificationService.Warning($translate.instant('button-label-mandatory'));
      return false;
    }
    if (preJoinButtonLabel && !preJoinButtonUrl) {
      NotificationService.Warning($translate.instant('button-url-mandatory'));
      return false;
    }
    if (preJoinButtonLabel && preJoinButtonUrl) {
      if (preJoinButtonLabel.length > 22) {
        NotificationService.Warning($translate.instant('button-label-max-length'));
        return false;
      }
      if (!urlPattern.test(preJoinButtonUrl)) {
        NotificationService.Warning($translate.instant('button-url-invalid'));
        return false;
      }
    }
    const requestTypes = {
      isWithAppointment: $scope.organizationArea.isWithAppointment,
      isWithoutAppointment: $scope.organizationArea.isWithoutAppointment,
      appointmentsFromTotem: $scope.organizationArea.appointmentsFromTotem,
    };
    if (!$scope.validateRequestType(requestTypes)) {
      return false;
    }
    if (
      $scope.organizationArea.isWithoutAppointment &&
      !$scope.validateWithoutAppointment($scope.organizationArea.withoutAppointment)
    ) {
      return false;
    }
    if (!$scope.validateRanges($scope.organizationArea.schedule)) {
      return false;
    }

    return true;
  };

  $scope.saveWithoutAppointment = () => {
    if ($scope.validateWithoutAppointment($scope.organizationArea.withoutAppointment)) {
      const data = {
        updateType: $scope.selectData.selectedOption,
        updateValues: { withoutAppointment: $scope.organizationArea.withoutAppointment },
      };
      $scope.save(data).then(() => {
        $scope.editStatus.withoutAppointment = cloneDeep(
          $scope.organizationArea.withoutAppointment,
        );
        $scope.editStatus.openEditingWithout = false;
      });
    }
  };

  $scope.saveLines = () => {
    const linesToValidate = $scope.organizationArea.dynamic ? $scope.dynamicLines : $scope.items;
    if ($scope.validateLines(linesToValidate)) {
      const data = {
        updateType: $scope.selectData.selectedOption,
        updateValues: {
          dynamic: $scope.organizationArea.dynamic,
          ...(!$scope.organizationArea.dynamic && {
            organizationLines: $scope.items.map((item) => item._id),
          }),
          ...($scope.organizationArea.dynamic && {
            organizationLines: $scope.dynamicLines.map((item) => item.organizationLineId),
            organizationDynamicLines: $scope.dynamicLines.map((item) => ({
              organizationLineId: item.organizationLineId,
              label: item.label,
              pinned: item.pinned,
              order: item.order,
            })),
          }),
        },
      };
      $scope.save(data).then(() => {
        $scope.editStatus.items = $scope.organizationArea.dynamic
          ? cloneDeep($scope.dynamicLines)
          : cloneDeep($scope.items);
        $scope.editStatus.openEditingLines = false;
      });
    }
  };

  $scope.saveMessages = () => {
    const data = {
      updateType: $scope.selectDataMessages.selectedOption,
      updateValues: { configuration: $scope.organizationArea.configuration },
    };
    $scope.save(data).then(() => {
      $scope.editStatus.messages = cloneDeep($scope.organizationArea.configuration.messages);
      $scope.editStatus.editingMessages = false;
    });
  };

  $scope.saveSchedule = () => {
    schedule.scheduleFormat($scope.organizationArea.schedule, $scope.exactSchedule, false);
    if ($scope.validateRanges($scope.organizationArea.schedule)) {
      const data = {
        updateType: $scope.selectData.selectedOption,
        updateValues: { schedule: $scope.organizationArea.schedule },
      };
      $scope.save(data).then(() => {
        $scope.editStatus.schedule = cloneDeep($scope.organizationArea.schedule);
        $scope.editStatus.openEditingDayList = false;
      });
    }
  };

  $scope.editLines = () => {
    $scope.editStatus.openEditingLines = true;
    $scope.selectData.selectedOption = 'all';
  };

  $scope.validateRanges = (schedule) => {
    let valid = true;
    const opened = schedule.filter((s) => s.open);
    for (let i = 0; i < opened.length; i++) {
      const day = opened[i];
      if (day.firstPeriod.opening >= day.firstPeriod.closing) {
        NotificationService.Warning(
          $translate
            .instant('opening_hours_first_period_msg_validator')
            .replace('{dayname}', $translate.instant(day.name)),
        );
        valid = false;
        break;
      }
      if (day.hasSecondPeriod) {
        if (day.secondPeriod.opening <= day.firstPeriod.closing) {
          NotificationService.Warning(
            $translate
              .instant('opening_hours_second_must_be_later_first_msg_validator')
              .replace('{dayname}', $translate.instant(day.name)),
          );
          valid = false;
          break;
        }

        if (day.secondPeriod.opening >= day.secondPeriod.closing) {
          NotificationService.Warning(
            $translate
              .instant('opening_hours_second_period_msg_validator')
              .replace('{dayname}', $translate.instant(day.name)),
          );
          valid = false;
          break;
        }
      }
    }
    return valid;
  };

  $scope.validateWithoutAppointment = (withoutAppointment) => {
    if (!withoutAppointment.withPriority && !withoutAppointment.withoutPriority) {
      NotificationService.Warning($translate.instant('min_one_priority_type'));
      return false;
    }

    if (
      !withoutAppointment.requestSource.reception &&
      !withoutAppointment.requestSource.totem &&
      !withoutAppointment.requestSource.mobileApp
    ) {
      NotificationService.Warning($translate.instant('min_one_request_type'));
      return false;
    }

    return true;
  };

  $scope.validateLabel = (name) => {
    if (!name) {
      NotificationService.Warning($translate.instant('mandatory_area_name'));
      return false;
    }

    if (name.length > 50) {
      NotificationService.Warning($translate.instant('max_length_name'));
      return false;
    }

    if (!namePattern.test(name)) {
      NotificationService.Warning($translate.instant('char_forbidden_name'));
      return false;
    }

    return true;
  };

  $scope.validateDescription = (description) => {
    if (description && description.length > 500) {
      NotificationService.Warning($translate.instant('max_length_description'));
      return false;
    }

    return true;
  };

  $scope.validateAliasPrefixDecorator = (aliasPrefixDecorator) => {
    if (aliasPrefixDecorator && aliasPrefixDecorator.length > 5) {
      NotificationService.Warning($translate.instant('max_length_prefix_decorator'));
      return false;
    }

    return true;
  };

  $scope.validateRequestType = (values) => {
    if (!values.isWithAppointment && !values.isWithoutAppointment) {
      NotificationService.Warning($translate.instant('min_one_request_type'));
      return false;
    }
    return true;
  };

  $scope.validateLines = (items) => {
    if (items.length <= 0) {
      NotificationService.Warning($translate.instant('min_fila_assign'));
      return false;
    }
    return true;
  };

  $scope.validateMessage = (postMessage) => {
    if (postMessage.length > 59) {
      NotificationService.Warning($translate.instant('max_length_post_check_in_message'));
      return false;
    }
    return true;
  };

  $scope.save = (data) => {
    schedule.scheduleFormat($scope.organizationArea.schedule, $scope.exactSchedule, false);
    if (organizationAreaId && data) {
      const optionsSave = {};
      optionsSave.data = data;
      optionsSave.organizationAreaId = organizationAreaId;
      optionsSave.organizationId = $scope.organizationArea.organizationId;

      if (validate()) {
        $scope.blockSaveButton = true;

        return OrganizationAreaService.UpdatePartial(optionsSave)
          .then(() => {
            NotificationService.Success($translate.instant('area_update_succ'));
          })
          .catch((error) => {
            ErrorService.handler(error);
            $scope.blockSaveButton = false;
          });
      }
    } else {
      if ($scope.organizationArea.dynamic) {
        $scope.organizationArea.organizationDynamicLines = $scope.dynamicLines.map((item) => ({
          organizationLineId: item.organizationLineId,
          label: item.label,
          pinned: item.pinned,
          order: item.order,
        }));
        $scope.organizationArea.organizationLines = $scope.dynamicLines.map(
          (item) => item.organizationLineId,
        );
      } else {
        $scope.organizationArea.organizationLines = $scope.items.map((item) => item._id);
      }

      if (validate()) {
        $scope.blockSaveButton = true;

        return OrganizationAreaService.Create($scope.organizationArea)
          .then(() => {
            NotificationService.Success($translate.instant('area_create_succ'));
            $uibModalInstance.close('cancel');
          })
          .catch((error) => {
            ErrorService.handler(error);
            $scope.blockSaveButton = false;
          });
      }
    }
  };

  // OSOM line selector
  $scope.selectLine = (selection) => {
    const itemSelected = {
      // _id: selection._id,
      label: selection.name,
      type: selection.type,
      // realType: selection.realType,
      // statistics: selection.statistics,
      // waitingPeople: selection.waitingPeople
    };

    if ($scope.organizationArea.dynamic) {
      itemSelected.organizationLineId = selection._id;
      itemSelected.pinned = !$scope.dynamicLines.length;
      itemSelected.isFirst = !$scope.dynamicLines.length;
      itemSelected.order = $scope.dynamicLines.length || 0;
      if (
        !includes(
          $scope.dynamicLines.map((item) => item._id),
          selection._id,
        )
      ) {
        $scope.dynamicLines.push(itemSelected);
      }
    } else {
      itemSelected._id = selection._id;
      if (
        !includes(
          $scope.items.map((item) => item._id),
          selection._id,
        )
      ) {
        $scope.items.push(itemSelected);
      }
    }
    populateAlreadyShown();
  };

  $scope.removeLine = (organizationLineId) => {
    if ($scope.organizationArea.dynamic) {
      $scope.dynamicLines = $scope.dynamicLines.filter(
        (item) => item.organizationLineId !== organizationLineId,
      );
      resetDynamicProperties();
    } else {
      $scope.items = $scope.items.filter((item) => item._id !== organizationLineId);
    }
    populateAlreadyShown();
  };

  $scope.changePinLine = (organizationLineId) => {
    const line = $scope.dynamicLines.find((item) => item.organizationLineId === organizationLineId);
    if (line) {
      line.pinned = !line.pinned;
    }
  };

  $scope.setHasSecondPeriod = (day, hasSecondPeriod) => {
    day.hasSecondPeriod = hasSecondPeriod;
  };

  $scope.applyToAll = (day) => {
    schedule.applyToAll(day, $scope.organizationArea.schedule);
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.cancelEdit = (attribute) => {
    switch (attribute) {
      case 'withoutAppointment':
        $scope.editStatus.openEditingWithout = false;
        $scope.organizationArea.withoutAppointment = cloneDeep(
          $scope.editStatus.withoutAppointment,
        );
        break;

      case 'lines':
        $scope.editStatus.openEditingLines = false;
        if ($scope.organizationArea.dynamic) {
          $scope.dynamicLines = cloneDeep($scope.editStatus.items);
        } else {
          $scope.items = cloneDeep($scope.editStatus.items);
        }
        break;

      case 'schedule':
        $scope.editStatus.openEditingDayList = false;
        $scope.organizationArea.schedule = cloneDeep($scope.editStatus.schedule);
        break;

      case 'messages':
        $scope.editStatus.editingMessages = false;
        $scope.organizationArea.configuration.messages = cloneDeep($scope.editStatus.messages);
        break;
      case 'survey':
        $scope.editStatus.openSurveyMonkey = false;
        break;

      default:
        break;
    }
  };

  $scope.validateNumber = () => {
    let number = parseInt($scope.organizationArea.maxNumbers);
    number = isNaN(number) ? 0 : number;
    $scope.organizationArea.maxNumbers = number;
  };

  $scope.maxNumberKeyPress = (e) => {
    if (e.keyCode === 101 || e.keyCode === 69) {
      e.preventDefault();
    }
  };

  $scope.saveSurvey = () => {
    if (validateSurveyMonkey()) {
      $scope.organizationArea.surveyMonkey = saveSurveyMonkeySettings();
      const data = {
        updateType: 'organization',
        updateValues: {
          surveyMonkey: $scope.organizationArea.surveyMonkey,
        },
      };
      $scope.save(data).then(() => {
        $scope.surveyMonkey = cloneDeep($scope.organizationArea.surveyMonkey);
        $scope.editStatus.openSurveyMonkey = false;
      });
    }
  };

  $scope.onChangeDynamic = () => {
    if ($scope.organizationArea.dynamic && $scope.items.length) {
      $scope.dynamicLines = $scope.items.map((item) => {
        const index = $scope.items.findIndex((i) => i._id === item._id);
        return {
          organizationLineId: item._id,
          label: item.label,
          type: 'organization-line',
          isFirst: !index,
          pinned: !index,
          order: index,
        };
      });
    } else if (!$scope.organizationArea.dynamic && $scope.dynamicLines.length) {
      $scope.items = $scope.dynamicLines.map((item) => ({
        _id: item.organizationLineId,
        label: item.label,
        type: 'organization-line',
      }));
    }
  };

  if (organizationAreaId) {
    OrganizationAreaService.GetWithLinesAsPromiseFromServer(organizationAreaId)
      .then((res) => {
        $timeout(() => {
          $scope.organizationArea = OrganizationAreaService.Copy(res);
          schedule.scheduleFormat($scope.organizationArea.schedule, $scope.exactSchedule);
          $scope.linesPopulated = res.organizationLinesPopulated;
          $scope.requestTypes = {
            value: {
              isWithoutAppointment: $scope.organizationArea.isWithoutAppointment,
              isWithAppointment: $scope.organizationArea.isWithAppointment,
              appointmentsFromTotem: get($scope.organizationArea, 'appointmentsFromTotem', false),
            },
            isBA: $scope.enterpriseType === 'ba',
          };
          // Define initial editing status
          $scope.editStatus = {
            openEditingLines: false,
            openEditingWith: false,
            openEditingWithout: false,
            openEditingDayList: false,
            openSurveyMonkey: false,
            withoutAppointment: cloneDeep($scope.organizationArea.withoutAppointment),
            schedule: cloneDeep($scope.organizationArea.schedule),
            messages: cloneDeep($scope.organizationArea.configuration.messages),
            items: [],
          };

          const linesPopulated = Object.values(res.organizationLinesPopulated);
          // Fill item with lines
          if (res.dynamic && res.organizationDynamicLines.length) {
            res.organizationDynamicLines.forEach((item) => {
              const lineFound = linesPopulated.find((lp) => lp._id === item.organizationLineId);
              const label = lineFound ? lineFound.label : item.label;
              const dynamicLine = {
                organizationLineId: item.organizationLineId,
                label,
                isFirst: false,
                pinned: item.pinned,
                order: item.order,
              };
              $scope.dynamicLines.push(dynamicLine);
              $scope.editStatus.items.push(dynamicLine);
            });
            const firstDynamicLine = head($scope.dynamicLines);
            firstDynamicLine.isFirst = true;
          } else if (!res.dynamic && res.organizationLines.length) {
            const lineItems = linesPopulated.map((line) => ({
              _id: line._id,
              label: line.label,
              type: line.type,
            }));
            $scope.items = lineItems;
            $scope.editStatus.items = lineItems;
          }

          populateAlreadyShown();
          populateSurveyMonkey();
        });
      })
      .catch(ErrorService.handler);
  }
};

module.exports = module.controller(
  'OrganizationAreaModalController',
  OrganizationAreaModalController,
);
